import React from 'react';
import Input from '../../../components/ui/Input';
import Icon from '../../../components/AppIcon';

const ClientDetailsStep = ({ formData, errors, handleInputChange }) => {
  return (
    <div className="space-y-6 md:space-y-8">
      <div className="bg-accent/10 border border-accent/20 rounded-lg p-4 md:p-6">
        <div className="flex gap-3 md:gap-4">
          <div className="flex-shrink-0">
            <Icon name="Users" size={24} color="var(--color-accent)" />
          </div>
          <div>
            <h3 className="font-semibold text-foreground mb-2 text-sm md:text-base lg:text-lg">
              Client Information
            </h3>
            <p className="text-sm md:text-base text-muted-foreground">
              Enter details for the client or project owner. They'll be able to view compliance status and site documentation if you grant them access.
            </p>
          </div>
        </div>
      </div>
      <div className="space-y-4 md:space-y-6">
        <Input
          label="Client Name"
          type="text"
          name="clientName"
          placeholder="e.g., ABC Property Developers Ltd"
          value={formData?.clientName}
          onChange={handleInputChange}
          error={errors?.clientName}
          required
          description="Company or individual name"
        />

        <Input
          label="Contact Person"
          type="text"
          name="clientContactPerson"
          placeholder="e.g., Sarah Johnson"
          value={formData?.clientContactPerson}
          onChange={handleInputChange}
          error={errors?.clientContactPerson}
          required
          description="Primary contact at client organization"
        />

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-6">
          <Input
            label="Contact Email"
            type="email"
            name="clientEmail"
            placeholder="e.g., sarah.johnson@abcproperty.co.uk"
            value={formData?.clientEmail}
            onChange={handleInputChange}
            error={errors?.clientEmail}
            required
          />

          <Input
            label="Contact Phone"
            type="tel"
            name="clientPhone"
            placeholder="e.g., 020 7946 0958"
            value={formData?.clientPhone}
            onChange={handleInputChange}
            error={errors?.clientPhone}
            required
            description="UK phone number"
          />
        </div>
      </div>
    </div>
  );
};

export default ClientDetailsStep;